import React, { useEffect, useState } from "react";
import ProjectsTable from "../ProjectsTable/ProjectsTable";
import FilterAPIs from "../../../../MasonyFixingsAPIs/FilterAPIs/FilterAPIs";
import ApiResponseHandler from "../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useNavigate } from 'react-router-dom';
import { Form, Row, Col, Card } from 'react-bootstrap';
import './ProjectsHome.css';
import { MdAddCircle } from "react-icons/md";
import ProjectsMap from "../ProjectsMap/ProjectsMap";
import { FaMapMarkedAlt } from "react-icons/fa";
import { useRef } from "react";

function ProjectsHome() {


    const cardRefs = useRef({});

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [searchString, setSearchString] = useState('');
    const [projectList, setProjectList] = useState([]);
    const [projectMapList, setProjectMapList] = useState([]);
    const [isScrolled, setIsScrolled] = useState(false);
    const [selectedProjectId, setSelectedProjectId] = useState(null);

    const [mapView, setMapView] = useState(true);

    const getProjectList = (string) => {
        const postJSON = { name: string };
        FilterAPIs.PostProjectFilter(postJSON)
            .then((projects) => {
                setProjectList(projects.data);
                setLoading(false);
            })
            .catch((err) => {
                ApiResponseHandler(err.response, navigate);
            });
    };


    const scrollToProjectCard = (projectId) => {
        setSelectedProjectId(projectId);

        const el = cardRefs.current[projectId];

        if (el) {
            el.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
            });
        }
    };

    useEffect(() => {
        getProjectList(searchString);
    }, [searchString]);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    if (loading) return <h4>Loading Project List...</h4>;

    return (
        <div className="projects-home-container">
            {/* Search Section */}
           {mapView ? 
           
            <div>
                <div className="project-section-header">
                    <div className="project-header-actions">
                        <button onClick={() => navigate('create')} className="edit-btn">
                            <MdAddCircle />
                            <span>Add Project</span>
                        </button>

                        <button className="cancel-btn" onClick={()=>setMapView(!mapView)}>List Search</button>
                    </div>
                </div>
            </div>
            :
           <Card className={`projects-search-card floating-search ${isScrolled ? 'shrink' : ''}`}>
                <Card.Body>
                    <Row className="mb-2">
                        <Col sm={8}>
                            <div className="projects-search-container">
                                <Form.Label>Search Project ({projectList.length}):</Form.Label>
                                <Form.Control
                                    value={searchString}
                                    onChange={(e) => setSearchString(e.target.value)}
                                    placeholder="Enter project title or CIS ID..."
                                />
                            </div>
                        </Col>
                        <Col sm={1}>
                        <div className="project-header-actions">
                            <button title='Use Map View' className="save-btn" onClick={() => setMapView(!mapView)}><FaMapMarkedAlt/></button>
                        </div>
                        </Col>
                        <Col className="projects-add-col">
                            <button 
                                className="projects-add-btn"
                                onClick={() => navigate('create')}
                            >
                                <MdAddCircle />
                                <span>Add Project</span>
                            </button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            }

            {/* Projects Table Section */}
            <div className="mt-2">

                {mapView ? 
                    <div className="project-map-search">
                        <div className="project-map-search-cards">
                            {projectMapList.map((project) => {
                                return(
                                    <div 
                                        key={project.id} 
                                        className={`project-map-search-card ${selectedProjectId === project.id ? "active" : ""}`}
                                        ref={(el) => (cardRefs.current[project.id] = el)}
                                        onClick={() => setSelectedProjectId(project.id)}
                                    >
                                        {/* <div className="project-section-header">
                                            <h5 className="section-title">{project.name}</h5>
                                        </div> */}
                                        <div className="project-section-body">
                                            <div className="project-section-body-item">
                                            <strong className="label">{project.name}</strong>
                                            </div>
                                        <div className="project-section-body-item">
                                            <span className="label">{project.cis_id ? project.cis_id : 'No CIS ID'} | {project.applicant ? project.applicant : 'No promotor'}</span>
                                        </div>
                                        
                                        </div>
                                        
                                    </div>
                                )
                            })}
                        </div>
                    <div  className="map-container">
                        <ProjectsMap editable={false} setProjectMapList={setProjectMapList} selectedProjectId={selectedProjectId} onMarkerClick={scrollToProjectCard} />
                    </div>
                    </div>
                    :
                    <ProjectsTable projectList={projectList} getProjectList={getProjectList} />
                }
                
                
                
            </div>
        </div>
    );
}

export default ProjectsHome;